import Vue from 'vue'
import 'v-phone-input/dist/v-phone-input.css'
import { VAutocomplete } from 'vuetify/lib'
import { createVPhoneInput } from 'v-phone-input'
import i18N from '@/plugins/i18n'

Vue.component('VAutocomplete', VAutocomplete)
const vPhoneInput = createVPhoneInput({
  defaultCountry: 'BR',
  enableSearchingCountry: false,
  countryLabel: i18N.t('commonWords.country'),
  label: i18N.t('templateEditDialog.actionFieldLabels.phoneNumber'),
  invalidMessage: ({ label, example }) =>
    i18N.t('commonPhrases.invalidPhoneMessage') + '. ' + i18N.t('commonWords.example') + ':' + example
})

export default vPhoneInput
